module.exports = __webpack_public_path__ + "img/teacher.1c1e5ab6.png";